<template>
  <div class="monthly">
    <div class="head">
      <!-- <div class="logo"></div> -->
      <img class="logo" src="@/assets/logo.png">
      <div class="title">{{month}}月热门歌单</div>
    </div>
    <div class="list">
      <div class="item"
        v-for="({songName, singerName, message, likeCount}, index) in songList"
        :key="index"
      >
        <div class="item__hd">
          <div class="item__index">{{index + 1}}.</div>
        </div>
        <div class="item__bd">
          <div class="song">
            <div class="song-name">{{songName}}</div>
            <div class="singer-name">{{singerName}}</div>
          </div>
          <!-- <div class="desc">
            {{message}}
          </div> -->
          <!-- <div class="comment">1314 评论</div> -->
          <div class="like">{{likeCount}} 喜欢</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import { CellGroup } from 'vant'
import api from '@/api'
import dayjs from 'dayjs'

export default {
  name: 'Monthly',
  components: {
  },
  data () {
    return {
      // songName: '告白气球',
      // singerName: '周杰伦',
      // message: '',
      // nickname: '',
      // checked: true,
      // date: '今天',
      month: '',
      songList: []
    }
  },
  methods: {
    async getList(month) {
      const res = await api.getMonthlyList(month)
      console.log(res)
      if (res.code === 0) {
        this.songList = res.data.list
      } else {
        this.$toast(res.message)
      }
    },
  },
  created () {
    const { month } = this.$route.query
    this.month = dayjs(month).format('MM').toString()
    this.getList(month)
  }
}
</script>

<style lang="less" scoped>
@icon-logo: '~@/assets/logo.png';

.monthly {
}
.head {
  display: flex;
  // justify-content: space-between;
  height: 60px;
  padding: 20px;
  .logo {
    // width: 100px;
    // width: auto;
    height: 20px;
    // background: url(@icon-logo) 0 0 no-repeat;
    // background-size: contain;
  }
  .title {
    margin-left: 20px;
    font-size: 20px;
    font-weight: bold;
    line-height: 1;
  }
}
.list {
  padding: 20px 0;
  border-top: 1px solid #f1f1f1;
  // border-radius: 20px 20px 0 0;
  .item {
    display: flex;
    margin-top: 30px;
    padding: 0 20px;
    line-height: 1;
    &:first-child {
      margin-top: 0;
    }
    &__index {
      margin-right: 10px;
      // margin-top: 15px;
      width: 28px;
      font-size: 20px;
      font-weight: bold;
      font-style: italic;
      text-align: center;
      color: #666;
    }
    .song {
      display: flex;
      align-items: center;
      // height: 20px;
    }
    .song-name {
      font-size: 20px;
      font-weight: bold;
      color: #000;
    }
    .singer-name {
      font-size: 14px;
      color: #666;
      &:before {
        content: '-';
        margin: 0 5px;
      }
    }
    .desc {
      margin-top: 10px;
      font-size: 14px;
      line-height: 20px;
      color: #999;
    }
    .like {
      margin-top: 10px;
      font-size: 14px;
      line-height: 20px;
      color: #999;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/monthly/index.vue